import type { WireAuthProviderAdminRecord } from '#layers/access/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const AuthProvider = withItemType<WireAuthProviderAdminRecord>().defineCollection({
	name: 'MonospaceAuthProvider',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		// `config` is selected so the edit dialog can prefill a provider's stored
		// settings. The admin read returns it as native JSON (never `clientSecret`,
		// which is write-only).
		defaultFields: ['id', 'apiName', 'preset', 'state', 'protocol', 'config'],
		endpoint: 'system/auth-providers',
	},
});
